import _ from 'lodash';
import store from 'store';
import { getDateTimeInSeconds } from './DateUtils';

const LocalStorageKey = '_alerts';

const getAllAlertsInStore = () => {
  return store.get(LocalStorageKey) || [];
};

const saveAlertsToStore = (alerts) => {
  store.set(LocalStorageKey, alerts);
};

const findAlertInStore = (componentId) => {
  return getAllAlertsInStore().find(item => item.componentId === componentId);
};

const removeAlertFromStore = (componentId) => {
  let alerts = getAllAlertsInStore();
  const index = alerts.findIndex(item => item.componentId === componentId);

  if (index > -1) {
    alerts.splice(index, 1);
  }
  
  alerts = _.remove(alert, (item) => {
    const time = getDateTimeInSeconds();
    return time > item.timeout;
  });

  saveAlertsToStore(alerts);
};

const addAlertToStore = (componentId, timeout, data) => {
  const alerts = getAllAlertsInStore();

  alerts.push({ componentId, timeout, data });

  saveAlertsToStore(alerts);
};

export { addAlertToStore, findAlertInStore, removeAlertFromStore };



// WEBPACK FOOTER //
// ./app/utils/AlertUtils.js